export const SECTION_IDS = {
  inicio: "inicio",
  comoFunciona: "como-funciona",
  sobre: "sobre",
  sinais: "sinais",
  resultados: "resultados",
  precos: "precos",
  testemunhos: "testemunhos",
  faq: "faq",
  comecar: "comecar",
  contacto: "contacto",
} as const;

export type SectionId = (typeof SECTION_IDS)[keyof typeof SECTION_IDS];

/** Secções observadas pelo scroll spy (ordem de aparição na página). */
export const NAV_SECTIONS: { id: SectionId; label: string }[] = [
  { id: SECTION_IDS.inicio, label: "Início" },
  { id: SECTION_IDS.comoFunciona, label: "Como funciona" },
  { id: SECTION_IDS.sobre, label: "Sobre" },
  { id: SECTION_IDS.sinais, label: "Sinais" },
  { id: SECTION_IDS.resultados, label: "Resultados" },
  { id: SECTION_IDS.precos, label: "Preços" },
  { id: SECTION_IDS.testemunhos, label: "Testemunhos" },
  { id: SECTION_IDS.faq, label: "FAQ" },
];

export const LEGACY_ROUTE_SECTION: Record<string, SectionId> = {
  "/about-us": SECTION_IDS.sobre,
  "/price": SECTION_IDS.precos,
  "/how-it-works": SECTION_IDS.comoFunciona,
  "/signals": SECTION_IDS.sinais,
};
